import { FC } from 'react';
import { ProducerPlacementClientForm } from './ProducerPlacementClientForm';

export const ProducerPlacementForm: FC = () => <ProducerPlacementClientForm />;
